import { render, staticRenderFns } from "./TransformingDataList.vue?vue&type=template&id=5a24fcef&scoped=true"
import script from "./TransformingDataList.vue?vue&type=script&lang=js"
export * from "./TransformingDataList.vue?vue&type=script&lang=js"
import style0 from "./TransformingDataList.vue?vue&type=style&index=0&id=5a24fcef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24fcef",
  null
  
)

export default component.exports